import React from 'react'
import { TextField } from '@mui/material'
import { useState } from 'react'
function MerEmail(props) {
    
    const [value,setValue] = useState(props.info.value);
    const [error, setError] = useState(null)

    // const isDisabled = () => {
    //     let emailIsValid = false;
    //     let passwordIsValid = false;

    //     if (this.state.email === "") {
    //         this.setState({
    //             email_error_text: null
    //         });
    //     } 
    //     else {
    //         if (validateEmail(this.state.email)) {
    //             emailIsValid = true
    //             this.setState({
    //                 email_error_text: null
    //             });
    //         } else {
    //             this.setState({
    //                 email_error_text: "Sorry, this is not a valid email"
    //             });
    //         }
    //     }
    // }

    return (
        <TextField 
        InputLabelProps={{
            style: { color: 'black' },
        }}
        disabled={!props.abled}
        sx={{marginTop:2,marginBottom:2, maxWidth:'75%', 
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: 'black',
                },
           },
           '& .MuiFormLabel-asterisk': {
            color: 'red', fontSize: '30px'
            }
        }}
        required={props.info.mandatory}
        autoComplete='off'
        value={value}
        onChange={(e) => {
            setValue(e.target.value);
            props.handleChange(props.info.id,e.target.value,props.info?._id);
        }}
        label={props.info.question_text}
        variant="outlined"
        type='email'
        />
    )
}

export default MerEmail
